// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_REMOVE_CASE } from "./constants"

export function removeCase(caseId) {
  return {
    type: DAMAGE_CASE_REMOVE_CASE,
    data: { caseId },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_REMOVE_CASE:
      const unsentCases = Object.getOwnPropertyNames(state.unsentCases)
        .filter(caseId => caseId !== action.data.caseId)
        .reduce((cases, caseId) => (cases[caseId] = state.unsentCases[caseId]) && cases, {})

      return {
        ...state,
        unsentCases,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/removeCase.js